import dynamic from 'next/dynamic';
import { useState } from 'react';
import BlockAnchor from '../base/block-anchor';

const TemplateVideo = dynamic(() => import('../template/TemplateVideo'));

const ResourceWatch = ({ width, data }) => {
  const [hideTitle, setHideTitle] = useState(false);
  const title =
    data?.field_watch_listen_content[0].template_media_block_type
      ?.field_title[0]?.value;

  return (
    <div className={'resource-watch'}>
      <div className={'inner-container'}>
        {/* Anchor of the nested media block (the parent block's own anchor
            is added by getComponentForBlock). */}
        <BlockAnchor
          anchor={data?.field_watch_listen_content?.[0]?.template_media_block_type?.anchor}
        />
        <span className={'page-sub'}>{title}</span>
        <hr />
        <div className={'watch-container'}>
          <TemplateVideo playOnTitleClick={true} width={width} hideTitle={true}>
            {data?.field_watch_listen_content[0].template_media_block_type}
          </TemplateVideo>
        </div>
      </div>
    </div>
  );
};

export default ResourceWatch;
